"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GreetingsWrap = styled_components_1.default.div(({ theme }) => theme.greetings);
const Greetings = ({ greetingsTextTranslation, firstName, lastName, loading, placeholder, }) => {
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null, placeholder);
    return (react_1.default.createElement(GreetingsWrap, { className: "greetings" },
        react_1.default.createElement("b", null, greetingsTextTranslation),
        react_1.default.createElement("span", { className: "name" }, firstName),
        react_1.default.createElement("span", { className: "name" }, lastName)));
};
exports.default = Greetings;
//# sourceMappingURL=Greetings.js.map